import { useContext, useState } from 'react';
import './Account.css'
import Modal from './modal';
import ReactDom from "react-dom"
import NavigationContext from '../context/Navigation';
import { GoChevronLeft } from "react-icons/go"


function Account({ route }) {

    const { Navigate, currentPath } = useContext(NavigationContext);

    const [name, setName] = useState("");
    const [location, setLocation] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleClick = (() => {



    })

    const handleChange = ((event) => {

        switch (event.target.name) {
            case 'name':
                setName(event.target.value);
                break;
            case 'location':
                setLocation(event.target.value);
                break;
            case 'email':
                setEmail(event.target.value);
                break;
            case 'password':
                setPassword(event.target.value);
                break;
        }
    })

    const handleform = ((event) => {
        event.preventDefault();
    })


    let outForm
    switch (route) {
        case 'login':
            outForm = <form className='form' onSubmit={handleform}>
                <div className='grid grid-cols-[min-content_auto] gap-4 text-center'>
                    <label> Email: </label>
                    <input type="text" id="email" value={email} onChange={handleChange} name="email" />
                    <label> Password: </label>
                    <input type="password" id="password" value={"*".repeat(password.length)} onChange={handleChange} name="password" />
                </div>
                <button className="button rounded p-2 text-xl w-min self-center border border-orange-500" type="submit" value="Submit" onClick={handleClick}>Login</button>
            </form>
            break;

        // case 'guest':
        //     outForm = <form className='form' onSubmit={handleform}>
        //         <div className='grid grid-cols-[min-content_auto] gap-4 text-center'>
        //             <label> Name: </label>
        //             <input type="text" id="name"  value={name} onChange={handleChange} name="name" />
        //             <label> Location: </label>
        //             <input type="text" id="location" value={location}  onChange={handleChange} name="location" />
        //         </div>
        //         <button className="button rounded p-2 text-xl" type="submit" value="Submit" onClick={handleClick}>Login</button>
        //     </form>
        //     break;

        case 'register':
            outForm = <form className='form' onSubmit={handleform}>
                <div className='grid grid-cols-[min-content_auto] gap-4 text-center'>
                    <label> Name: </label>
                    <input type="text" id="name" value={name} onChange={handleChange} name="name" />
                    <label> Location: </label>
                    <input type="text" id="location" value={location} onChange={handleChange} name="location" />
                    <label> Email: </label>
                    <input type="text" id="email" value={email} onChange={handleChange} name="email" />
                    <label> Password: </label>
                    <input type="password" id="password" value={"*".repeat(password.length)} onChange={handleChange} name="password" />
                </div>
                <button className="button rounded p-2 text-xl w-min self-center border border-orange-500" type="submit" value="Submit" onClick={handleClick}>Register</button>
            </form>
            break;

        default:
            outForm = <div></div>
            break;

    }

    return ReactDom.createPortal(
        <div className="Account">
            <div className="background fixed inset-0 bg-black bg-opacity-40" ></div>
            <div className="modal rounded-3xl bg-[#242424] border-2 border-orange-500 h-max fixed w-max flex flex-col top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 items-center p-4 ">
                <button className="button border rounded p-2 mb-3 text-xl border border-orange-500 flex" onClick={() => Navigate('/')} >
                    <GoChevronLeft className="inline text-2xl self-center pr-1 " /> Back
                </button>
                {outForm}
            </div>
        </div>, document.querySelector('.modal-container'))

}

export default Account